export default __webpack_public_path__ + "static/media/LINK.24598efa.svg";